"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SubstitutedUser_1 = require("../model/SubstitutedUser");

var SubstitutedUserConverter_1 = require("./SubstitutedUserConverter");
/**
 * Default implementation of substituted user converter.
 *
 * @author Radek Beran
 */


var SubstitutedUserConverterImpl =
/*#__PURE__*/
function (_SubstitutedUserConve) {
  _inherits(SubstitutedUserConverterImpl, _SubstitutedUserConve);

  function SubstitutedUserConverterImpl() {
    _classCallCheck(this, SubstitutedUserConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SubstitutedUserConverterImpl).apply(this, arguments));
  }

  _createClass(SubstitutedUserConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SubstitutedUser_1.SubstitutedUser(source.id, source.username, source.email, source.firstName, source.lastName);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        id: source.id
      });
      Object.assign(result, {
        username: source.username
      });
      Object.assign(result, {
        email: source.email
      });
      Object.assign(result, {
        firstName: source.firstName
      });
      Object.assign(result, {
        lastName: source.lastName
      });
      return result;
    }
  }]);

  return SubstitutedUserConverterImpl;
}(SubstitutedUserConverter_1.SubstitutedUserConverter);

exports.SubstitutedUserConverterImpl = SubstitutedUserConverterImpl;